<div class="pia-revisions hide-for-print">
  @if (title) {
  <div class="pia-revisions-title">
    <fa-icon [icon]="faHistory"></fa-icon>
    {{ "summary.revision.revision" | translate }}
  </div>
  } @if (revisions) {
  <div class="pia-revisions-box">
    <h4>{{ "summary.revision.pia_version" | translate }}</h4>
    <p>
      <fa-icon [icon]="faCircle"></fa-icon>
      {{ currentVersion | date: "short":"":languagesService.selectedLanguage }}
      - {{ "summary.revision.current_version" | translate }}
    </p>
    @if (revisions.length > 0) {
    <a
      href="javascript;"
      class="pia-revisions-box-footer"
      (click)="opened = !opened; $event.preventDefault()"
    >
      <span>{{
        "summary.revision.show" | translate: { length: revisions.length }
      }}</span>
      @if (!opened) {
      <fa-icon [icon]="faChevronDown"></fa-icon>
      } @else {
      <fa-icon [icon]="faChevronUp"></fa-icon>
      }
    </a>
    } @if (opened && revisionsGroupByMonth) {
    <div class="pia-revisions-box-content">
      @for (date of revisionsGroupByMonthInArray.reverse(); track date) {
      <div class="pia-revisions-box-content-revision">
        <h5>{{ date }}</h5>
        <ul>
          @for (revision of revisionsGroupByMonth[date]; track revision) {
          <li
            class="pia-revisions-box-content-revision-item"
            [attr.revision-id]="revision.id"
          >
            <span
              (click)="
                previewRevision(revision.id, $event, revision.created_at)
              "
            >
              <fa-icon
                [icon]="faCircle"
                class="revision-not-selected "
              ></fa-icon>
              <fa-icon
                [icon]="faCircleCheck"
                class="revision-selected hide"
              ></fa-icon>
              {{
                revision.created_at
                  | date: "short":"":languagesService.selectedLanguage
              }}
            </span>
          </li>
          }
        </ul>
      </div>
      }
    </div>
    } @if ( ['author', 'validator', 'evaluator'].indexOf(editMode[0]) >= 0 ||
    editMode === 'local' ) {
    <button class="pia-revisions-new" (click)="newRevision()">
      <span class="pia-icons pia-icon-add-white"></span>
      {{ "summary.revision.save" | translate }}
    </button>
    }
  </div>
  }
</div>
@if (preview) {
<app-modal
  (clickOnClose)="preview = null"
  specialClass="revision-preview-modal"
>
  @if (preview) {
  <app-revision-preview [revision]="preview" [editMode]="editMode">
  </app-revision-preview>
  }
</app-modal>
}
